import '../css/statusbar.css';
import {useState} from 'react';

export const StatusBar = ({props}) => {
  let {
    totalToday,
    card,
    history,
    cards,
    sessionReviews,
    bothSides,
    setBothSides,
    useRandomOrder,
    setUseRandomOrder,
  } = props;
  const [revealDetails, setRevealDetails] = useState(false);
  const brierScore = (history) => {
    
    let max_review = 0;
    for (let k in history) {
      let m = history[k].map(x=>x.review).reduce((a,x) => x > a ? x : a, 0);
      if (m > max_review) {
        max_review = m;
      }
    }

    let accum = 0;
    for (let k in history) {
      let seq = history[k].filter(x => x.review > (max_review - sessionReviews) );
      let elements = seq.map(x => x.p_correct ? (x.p_correct - x.was_correct)*(x.p_correct - x.was_correct) : 0)
      accum = accum + elements.reduce((a,x) => a + x, 0)
    }
    return Math.round(accum*1000 / sessionReviews)/1000;
  }
  
  const handleBothSidesChange = (e) => {
    e.stopPropagation();
    setBothSides(!bothSides); 
  }

  const handleRandomOrderChange = (e) => {
    e.stopPropagation();
    setUseRandomOrder(!useRandomOrder);
  }

  return (
    <div className={'status-bar ' + (revealDetails && 'extra')} onClick={() => setRevealDetails(x => (! x))}>
      <div className="line">
        <span className='text-element overall' >
          learned: {Object.keys(history).length + (card.card_id in history ? 0 : 1)} / {cards.length}
        </span>
        <span className='text-element session'>
          today: {totalToday}
        </span>
      </div>
     { revealDetails && (
      <>
        <div className="line">
          <span className='text-element overall' >
            brier: {brierScore(history)}
          </span>
          <span className='checkbox' onClick={handleBothSidesChange}>
            <input type="checkbox" checked={bothSides} onChange={()=>undefined}/>
            show both sides
          </span>
        </div>
        <div className="line line-right">
          <span className='checkbox' onClick={handleRandomOrderChange}>
            <input type="checkbox" checked={useRandomOrder} onChange={()=>undefined}/>
            random order
          </span>
        </div>
      </>
      ) }
    </div>
  )
}
/* 
second line in statusbar:

      <div className="line">
       <span className='text-element overall'>
       {Math.round(integralDelta/2e8/1e-7)*1e-7}
       </span>
       <span className='session text-element'>
       {Math.round(halfLife/3.6e3/1e2)*1e2}
       </span>
       </div>
       */
export default StatusBar;
